import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './Microneedling.css';

function Microneedling() {
  const { t } = useTranslation();

  return (
    <div className="microneedling-page">
      {/* Hero Section */}
      <section className="microneedling-hero">
        <div className="container">
          <h1>Microneedling</h1>
          <p className="hero-subtitle">
            Advanced Collagen Induction Therapy using Dr Pen A20
          </p>
          <p className="hero-description">
            Microneedling is a minimally invasive skin rejuvenation procedure designed to enhance collagen and elastin production. 
            Using precision-controlled micro-needling technology, we create micro-channels in the skin that trigger a natural 
            healing response — improving texture, tone, and firmness while maintaining skin integrity.
          </p>
          <p className="hero-note">
            At Sapium Beauty, we perform microneedling exclusively with the Dr Pen A20, a professional, medical-grade device 
            trusted for its accuracy, hygiene, and excellent clinical outcomes.
          </p>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="microneedling-content">
        <div className="container">
          <div className="content-wrapper">
            {/* Treatment Summary */}
            <div className="content-section">
              <h2>Treatment Summary</h2>
              <ul className="summary-list">
                <li>Procedure time: 45–60 minutes</li>
                <li>Full recovery: mild redness for 24–48 hours</li>
                <li>Anaesthetic: numbing cream available if required</li>
                <li>Risks and complications: temporary redness, mild swelling, sensitivity; less common – bruising or temporary pigmentation changes</li>
              </ul>
            </div>

            {/* Indications & Benefits */}
            <div className="content-section">
              <h2>Indications & Benefits</h2>
              <p>
                Microneedling is suitable for improving the appearance of:
              </p>
              <ul className="benefits-list">
                <li>Fine lines and early signs of ageing</li>
                <li>Acne scarring and post-inflammatory texture</li>
                <li>Pigmentation irregularities and sun damage</li>
                <li>Enlarged pores</li>
                <li>Dull, dehydrated skin lacking vitality</li>
                <li>Stretch marks (selected areas)</li>
                <li>Mild skin laxity and uneven tone</li>
              </ul>
              <div className="highlight-note">
                <p>
                  <strong>Skin becomes smoother, firmer, and visibly more radiant over a course of treatments.</strong>
                </p>
              </div>
            </div>

            {/* Treatment Protocol */}
            <div className="content-section">
              <h2>Treatment Protocol (Every session includes)</h2>
              <ul className="protocol-list">
                <li>Professional double cleanse</li>
                <li>Enzyme resurfacing preparation</li>
                <li>Microneedling using Dr Pen A20</li>
                <li>Face mask to support healing and reduce inflammation</li>
                <li>Barrier-repair moisturiser and high-protection SPF</li>
              </ul>
            </div>

            {/* Aftercare Guidance */}
            <div className="content-section">
              <h2>Aftercare Guidance</h2>
              <p>
                To ensure optimal results:
              </p>
              <ul className="aftercare-list">
                <li>Avoid makeup, strenuous exercise, heat, and steam for 24 hours</li>
                <li>Avoid active skincare (retinol, AHA/BHA) for 5–7 days</li>
                <li>Maintain hydration with gentle, barrier-supportive products</li>
                <li>Apply SPF 30+ daily and avoid direct UV exposure for 1–2 weeks</li>
              </ul>
              <p className="aftercare-note">
                <em>Mild tightness or sensitivity is expected and resolves quickly.</em>
              </p>
            </div>

            {/* Contraindications */}
            <div className="content-section">
              <h2>Contraindications</h2>
              <p>
                Microneedling is not suitable for individuals who:
              </p>
              <ul className="contraindications-list">
                <li>Are pregnant or breastfeeding</li>
                <li>Are taking prescription acne medication (e.g., isotretinoin)</li>
                <li>Used retinol or AHA/BHA within the last 7 days</li>
                <li>Have active cold sores, acne flare, or infectious skin concerns</li>
                <li>Have eczema, psoriasis, or dermatitis in the treatment area</li>
                <li>Have received fillers or Botox within the past 2 weeks</li>
                <li>Have fresh bruising or recent skin trauma</li>
                <li>Have uncontrolled diabetes</li>
                <li>Have scar tissue less than 6 months old</li>
                <li>Are undergoing cancer treatment</li>
              </ul>
            </div>

            {/* Why Choose Sapium Beauty */}
            <div className="content-section">
              <h2>Why Choose Sapium Beauty?</h2>
              <ul className="why-choose-list">
                <li>Premium professional device: Dr Pen A20</li>
                <li>Highly trained and certified aesthetic practitioner</li>
                <li>Strict hygiene and safety protocols</li>
                <li>Personalised treatment plans</li>
                <li>Natural, progressive, clinically backed results</li>
              </ul>
            </div>

            {/* CTA Section */}
            <div className="cta-section">
              <h2>{t('services.cta.title')}</h2>
              <p>{t('services.cta.description')}</p>
              <div className="cta-buttons">
                <a href="https://www.fresha.com/book-now/sapium-beauty-hu8f8ild/all-offer?share=true&pId=2743251" target="_blank" rel="noopener noreferrer" className="cta-button primary">{t('services.cta.button')}</a>
                <Link to="/services" className="cta-button secondary">Back to Services</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Microneedling;

